import { useEffect }    from 'react';
import { connect }      from 'react-redux';
// Redux
import {getHistory}    from '../../redux/actions/History';
// Components
import Head         from '../global/Head';
import Tables       from './Tables';
import Form         from './Form';
// Values
import {StateView}  from '../../values';
// Api
import {getData}    from '../../utils/history';

const Index = ({stateView, token, getHistory}) => {
    const GetData = async() =>{
        const res = await getData(token)
        getHistory(res.data)
    }
    useEffect(() =>{
        if(token){
            if(stateView === StateView.state1){
                GetData()
            }
        }
    })
    return (
        <div>
            <Head title='Historial' view={false} />
            {
                stateView===StateView.state1?
                    <Tables />
                :
                    <Form />
            }
        </div>
    );
};

const mapStateToProps = state =>({
    stateView:      state.View.stateView,
    token:          state.Panel.token
})

export default connect(mapStateToProps, {getHistory})(Index);
